import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { GeographicalScopeListComponent } from './geographical-scope-list/geographical-scope-list.component'

export const geographicalScopeRoutes: Route[] = [
  {
    path: 'geographical-scopes',
    component: GeographicalScopeListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'geographical-scopes/:id/edit',
    redirectTo: 'geographical-scopes/:id',
    pathMatch: 'full'
  },
  {
    path: 'geographical-scopes/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'GeographicalScope',
        nameSingular: 'Geographical Scope',
        namePlural: 'Geographical Scopes',
        path: 'geographical-scopes',
        slug: 'taxonomies/geographical-scopes',
        title: 'Geographical Scopes'
      }),
      permission: 'readTaxonomies'
    }
  }
]
